import React from 'react'
import { MagnifyingGlass } from '@phosphor-icons/react'

const SearchBar = ({onClick, id, value, onChange}) => {
  return (
    <React.Fragment>
      <div className="w-full relative flex flex-nowrap flex-1 items-center rounded-full border border-solid border-neutral-400 bg-transparent bg-clip-padding  focus:border-primary focus:shadow-inset focus:outline-none focus:z-[3]  dark:focus:border-primary">
        <input
          type="search"
          className="relative m-0 mx-2 w-full block flex-auto px-3 py-[0.25rem] text-base rounded-full border-none font-normal leading-[1.6] text-surface outline-none transition duration-200 ease-in-out placeholder:text-neutral-500 motion-reduce:transition-none dark:border-black/10 dark:text-black dark:placeholder:text-black-400 dark:autofill:shadow-autofill"
          placeholder="SEARCH"
          aria-label="SEARCH"
          id={id}
          aria-describedby="button-addon2"
          value={value}
          onChange={onChange}
        />
        <MagnifyingGlass
          className="pointer-events-none right-0 mr-4"
          size={20}
        />
      </div>
    </React.Fragment>
  );
};

export default SearchBar